<template>
  <router-view />
</template>

<script>
// This forks App and SilentSignin, so that the normal authentication attempts etc
// don't happen if the SilentSignin route is accessed. All the SilentSignin does is
// send a callback message to the parent window
// (the oidc client's silent flow iframe accesses this route).
export default {};
</script>

<style></style>
